import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export interface BodyTextProps {
  /**
   * Affects the tracking of the text.
   */
  tight?: boolean
  className?: string
  style?: React.CSSProperties
}

const BODY_STYLES =
  'font-body text-body text-sm font-normal p-0 m-0 line-clamp-2 text-darkgray'

export const Body: React.FC<PropsWithChildren<BodyTextProps>> = ({
  children,
  className,
  style,
  tight,
}) => (
  <p
    className={concatStyles([
      BODY_STYLES,
      tight ? 'tracking-tight' : null,
      className,
    ])}
    style={style}
  >
    {children}
  </p>
)

Body.displayName = 'Card.Body'
